const ACTIVITY_PLACE_STATUS = {
  PENDING: 'PENDING',
  IN_REVIEW: 'IN_REVIEW',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
};

const ACTIVITY_PLACE_STATUS_ENUM = Object.keys(ACTIVITY_PLACE_STATUS);

export {
  ACTIVITY_PLACE_STATUS, ACTIVITY_PLACE_STATUS_ENUM,
};
